var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "modal-drag_svg__Group",
    transform: "translate(.5 .5)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.776 3.778h.001v34h-34s-8.499 8.498 0-.002l34-33.998c8.499-8.5 0 0 0 0z",
    id: "modal-drag_svg__Vector-shape",
    fill: "#212C30",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.42 34.407L33.848 20.98",
    id: "modal-drag_svg__Line",
    fill: "none",
    stroke: "#474747",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.134 34.407l6.713-6.714",
    id: "modal-drag_svg__Line-Copy",
    fill: "none",
    stroke: "#474747",
    strokeWidth: 1
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iNDNweCIgaGVpZ2h0PSI0M3B4IiB2aWV3Qm94PSIwIDAgNDMgNDMiIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC41KSI+CiAgICA8cGF0aCBkPSJNMzcuNzc2MiAzLjc3NzYyTDM3Ljc3NzEgMy43Nzc2MkwzNy43NzcxIDM3Ljc3NzFMMy43Nzc2MiAzNy43NzcxQzMuNzc3NjIgMzcuNzc3MSAtNC43MjIwMiA0Ni4yNzYgMy43Nzc2MiAzNy43NzYyQzEyLjI3NzMgMjkuMjc2MyAyOS4yNzY1IDEyLjI3NzMgMzcuNzc2MiAzLjc3NzYyQzQ2LjI3NTggLTQuNzIyMDIgMzcuNzc2MiAzLjc3NzYyIDM3Ljc3NjIgMy43Nzc2MloiIGlkPSJWZWN0b3Itc2hhcGUiIGZpbGw9IiMyMTJDMzAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSJub25lIiAvPgogICAgPHBhdGggZD0iTTAgMTMuNDI2M0wxMy40MjYzIDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjQyMDc3NiAyMC45ODAzNDcpIiBpZD0iTGluZSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS13aWR0aD0iMSIgLz4KICAgIDxwYXRoIGQ9Ik0wIDYuNzEzMTVMNi43MTMxNCAwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy4xMzM5MTEgMjcuNjkzNDIpIiBpZD0iTGluZS1Db3B5IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzQ3NDc0NyIgc3Ryb2tlLXdpZHRoPSIxIiAvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgModalDrag as ReactComponent };